<template>
    <div class="header-component" v-if="!$route.meta.hideHeader" :data-name="$route.name">
        <div class="container-fluid">
            <div class="row justify-content-between">
                <div class="col-auto left text-start">
                    <router-link to="/your-dashboard">
                        <img :src="logo" alt="JCT600 Vehicle Leasing Solutions | Origo" />
                    </router-link>
                </div>

                <div class="col-auto center text-center">
                    <header-logo :customerLogo="customerLogo" :customerName="customerName" :session="session"></header-logo>
                </div>

                <div class="col-auto right text-end" v-if="session.policiesAccepted">
                    <nav>
                        <router-link v-if="session && session.profile" :to="{ name: session.policiesAccepted ? 'My Details and Documents' :  '' }">Hi {{ session.profile.firstName }}</router-link>
                        <router-link v-if="session && session.profile" :to="{ name: session.policiesAccepted ? 'Your Dashboard' :  '' }">Your Dashboard</router-link>
                        <a href="/logout" @click.prevent="logout">Logout</a>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from '@/event-bus.js';

    export default {

        methods: {
            logout() {
                EventBus.$emit('loadingTitle', 'Logging Out');
                EventBus.$emit('loading', true);

                this.$http.get('/logout').then(response => {
                    EventBus.$emit('loading', false);
                    this.$router.push({ name: 'Login'});
                    EventBus.$emit('clearSession', true);
                });
            }
        },

        computed: {
            logo() {
                return this.adminPortalData.content ? process.env.MIX_ADMIN_PORTAL_URL + this.adminPortalData.content.global.logo : '';
            },

            customerLogo() {
                return this.adminPortalData.content?.customer?.logo ? process.env.MIX_ADMIN_PORTAL_URL + this.adminPortalData.content.customer.logo : false;
            },

            customerName() {
                return this.adminPortalData.content?.customer?.name ? this.adminPortalData.content.customer.name : false;
            },
        },

        props: [
            'session',
            'adminPortalData',
            'policiesAccepted'
        ]

    }
</script>
